module.exports = __webpack_public_path__ + "media/pricing/box-mobile-c853ea09.png";